<template>
    <div>
        <b-row>
            <b-col>
                <h3>Шаг {{ step_num }}  из {{ stepsCount }} : {{ stepItem.title }}</h3>
            </b-col>
        </b-row>
        <b-row>
            <b-col>
                <b-progress 
                    :value="currentStep" 
                    :max="stepsCount" 
                    :variant="currentStep === stepsCount ? 'success' : ''"></b-progress>
                <br />
            </b-col>
        </b-row>
    </div>
</template>

<script>
import steps from '../steps.js'

export default {
    props: {
        step_num : Number
    },
    data() {
        return {

        }
    },
    computed: {
        stepItem() { return steps.get(this.step_num) },
        stepsCount() { return steps.items.length - 1 },
        currentStep() {
            let step = steps.get(this.$route.path.replace('/',''))
            return step ? step.num : 0
        }
    }
}
</script>